export enum ProgramTemplateMedicineTableColummTitle {
  ProtectedDrugName = "Zaštićeni naziv lijeka",
  Type = "Vrsta",
  Inn = "INN",
}
